import React from 'react';

export const ShowReview = ({ title, description }: any): JSX.Element => {
    return (
        <div>
            <div className="mt-2 lh-1 fw-bold border-light-dark text-bold text-dark me-2 fs-7">
                {title}:
            </div>
            <div className="d-block w-100">
                <div className={`badge badge-light-info border fs-8 text-wrap w-100`}>
                    {description}
                </div>
            </div>
        </div>
    );
};